import { schema } from 'normalizr';
import vital from './vital';
import personalCareTask from './personalCareTask';
import activity from './activity';
import incidentReport from './incidentReport';
import homeMakingTask from './homeMakingTask';

const shiftReport = new schema.Entity('shiftReports', {
  vitals: [vital],
  personalCareTasks: [personalCareTask],
  homeMakingTasks: [homeMakingTask],
  activities: [activity],
  incidentReports: [incidentReport],
});

export default shiftReport;
